// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"AuthenticationList_button-wrapper__1wvF0","text-hint":"AuthenticationList_text-hint__1WwMO"};